import { render, staticRenderFns } from "./AvatarContent.vue?vue&type=template&id=6ffbda1c&"
import script from "./AvatarContent.vue?vue&type=script&lang=js&"
export * from "./AvatarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports